import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";

import { CollectionFieldComponent } from "./collection/collection-field.component";
import { CollectionDirective } from "./collection/collection.component";
import { ContainerComponent } from "./container/container.component";
import { TabContainerTabDirective } from "./tab-container/tab-container-tab.component";
import { TabContainerComponent } from "./tab-container/tab-container.component";
import { TodoListComponent } from "./todo-list/todo-list.component";
import { LoadingIndicatorModule } from "../loading-indicator/loading-indicator.module";

@NgModule({
	imports: [CommonModule, LoadingIndicatorModule, MatTabsModule],
	declarations: [
		ContainerComponent,
		CollectionFieldComponent,
		CollectionDirective,
		TabContainerComponent,
		TabContainerTabDirective,
		TodoListComponent,
	],
	exports: [
		ContainerComponent,
		CollectionFieldComponent,
		CollectionDirective,
		TabContainerComponent,
		TabContainerTabDirective,
		TodoListComponent,
	],
})
export class ContainerModule {}
